module.exports = __webpack_public_path__ + "img/facebook.9b88265b.svg";